// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

.sq-shell {
  min-height: 100vh;
  min-height: 100dvh;
}

.sq-skip {
  position: absolute;
  left: 0.75rem;
  top: -4rem;
  z-index: 2000;
  padding: 0.5rem 0.875rem;
  background: var(--sq-surface);
  color: var(--sq-navy);
  border-radius: var(--sq-radius-sm);
  box-shadow: var(--sq-shadow-lg);
  font-weight: 600;
}
.sq-skip:focus {
  top: 0.75rem;
}

.sq-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  margin-left: var(--sq-sidebar-w);
}
@media (max-width: 991px) {
  .sq-main {
    margin-left: 0;
    min-height: 0;
    padding-top: var(--sq-topbar-h);
    padding-bottom: calc(var(--sq-bottomnav-h) + var(--sq-safe-bottom));
  }
}

.sq-content {
  flex: 1 1;
  min-width: 0;
}

.sq-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: var(--sq-sidebar-w);
  background: var(--sq-navy-deep);
  color: #fff;
}
@media (max-width: 991px) {
  .sq-sidebar {
    display: none;
  }
}

.sq-sidebar-brand {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 1rem 1.125rem 0.875rem;
}
.sq-sidebar-brand img {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
}
.sq-sidebar-brand span {
  font-size: 0.9375rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: #fff;
}

.sq-sidebar-nav {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.25rem 0.625rem 0.75rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

.sq-nav,
.sq-nav-sub {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sq-nav > li + li {
  margin-top: 2px;
}

.sq-nav-link {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  min-height: 38px;
  padding: 0.4rem 0.625rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.78);
  background: transparent;
  border: 0;
  border-radius: var(--sq-radius-sm);
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.sq-nav-link svg {
  flex-shrink: 0;
}
.sq-nav-link > span {
  flex: 1 1;
  min-width: 0;
}
.sq-nav-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.sq-nav-link:focus-visible {
  box-shadow: 0 0 0 2px var(--sq-sky);
}
.sq-nav-link.is-within {
  color: #fff;
}
.sq-nav-link.active {
  background: var(--sq-brand-strong);
  color: #fff;
  font-weight: 600;
}

.sq-nav-caret {
  opacity: 0.6;
  transition: transform 0.15s ease;
}
.sq-nav-caret.is-open {
  transform: rotate(90deg);
}

.sq-nav-sub {
  margin: 2px 0 4px 1.125rem;
  padding-left: 0.625rem;
  border-left: 1px solid rgba(255, 255, 255, 0.14);
}
.sq-nav-sub li + li {
  margin-top: 2px;
}
.sq-nav-sub .sq-nav-link {
  min-height: 34px;
  font-size: 0.8125rem;
}

.sq-user {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.75rem 0.875rem;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.sq-user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--sq-navy-deep);
  background: var(--sq-sky);
  border-radius: 50%;
}

.sq-user-name {
  flex: 1 1;
  min-width: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sq-user-logout {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 0;
  color: rgba(255, 255, 255, 0.78);
  background: transparent;
  border: 0;
  border-radius: var(--sq-radius-sm);
  cursor: pointer;
}
.sq-user-logout:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.sq-user-logout:focus-visible {
  box-shadow: 0 0 0 2px var(--sq-sky);
}

.sq-topbar {
  display: none;
}
@media (max-width: 991px) {
  .sq-topbar {
    position: fixed;
    inset: 0 0 auto 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 0.625rem;
    height: var(--sq-topbar-h);
    padding: 0 var(--sq-page-x);
    background: var(--sq-navy-deep);
    color: #fff;
  }
}

.sq-topbar-mark {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 7px;
  flex-shrink: 0;
}

.sq-topbar-title {
  min-width: 0;
  font-size: 1rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sq-bottomnav {
  display: none;
}
@media (max-width: 991px) {
  .sq-bottomnav {
    position: fixed;
    inset: auto 0 0 0;
    z-index: 1000;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    height: calc(var(--sq-bottomnav-h) + var(--sq-safe-bottom));
    padding-bottom: var(--sq-safe-bottom);
    background: var(--sq-surface);
    border-top: 1px solid var(--sq-border);
    box-shadow: 0 -2px 10px rgba(16, 33, 47, 0.06);
  }
}

.sq-bottomnav-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
  min-width: 0;
  padding: 0.25rem 0.125rem;
  font-size: 0.6875rem;
  font-weight: 500;
  color: var(--sq-text-3);
  background: transparent;
  border: 0;
  text-decoration: none;
  cursor: pointer;
}
.sq-bottomnav-link:hover {
  color: var(--sq-navy);
}
.sq-bottomnav-link:focus-visible {
  box-shadow: inset 0 0 0 2px var(--sq-navy);
}
.sq-bottomnav-link.active {
  color: var(--sq-brand-strong);
  font-weight: 650;
}

.MuiPaper-root.sq-menu-sheet {
  max-height: calc(100dvh - 48px);
  background: var(--sq-navy-deep);
  color: #fff;
}

.sq-menu-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.5rem 0.25rem 1.125rem;
  font-size: 1rem;
  font-weight: 650;
}
.sq-menu-head button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  color: #fff;
  background: transparent;
  border: 0;
  border-radius: var(--sq-radius-sm);
  cursor: pointer;
}

.sq-menu-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.25rem 0.625rem 0.5rem;
}
.sq-menu-body .sq-nav-link {
  min-height: 44px;
  font-size: 0.9375rem;
}
.sq-menu-body .sq-nav-sub .sq-nav-link {
  min-height: 44px;
  font-size: 0.875rem;
}

.sq-menu-sheet .sq-user-logout {
  width: 44px;
  height: 44px;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/components/layouts/SidebarLayout.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AArDA;EACE,iBAAA;EACA,kBAAA;AAwDF;;AArDA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,wBAAA;EACA,6BAAA;EACA,qBAAA;EACA,kCAAA;EACA,+BAAA;EACA,gBAAA;AAwDF;AAtDE;EACE,YAAA;AAwDJ;;AAjDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAoDF;AAlDE;EARF;IASI,cAAA;IACA,aAAA;IACA,+BAAA;IACA,mEAAA;EAqDF;AACF;;AAlDA;EACE,SAAA;EACA,YAAA;AAqDF;;AAhDA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,+BAAA;EACA,WAAA;AAmDF;AAjDE;EAVF;IAWI,aAAA;EAoDF;AACF;;AAjDA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,+BAAA;AAoDF;AAlDE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAoDJ;AAjDE;EACE,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAmDJ;;AA/CA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,qBAAA;EACA,qDAAA;AAkDF;;AA7CA;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AAgDF;;AA7CA;EACE,eAAA;AAgDF;;AA7CA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;EACA,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;EACA,yDAAA;AAgDF;AA9CE;EACE,cAAA;AAgDJ;AA7CE;EACE,SAAA;EACA,YAAA;AA+CJ;AA5CE;EACE,qCAAA;EACA,WAAA;AA8CJ;AA3CE;EACE,mCAAA;AA6CJ;AA1CE;EACE,WAAA;AA4CJ;AAzCE;EACE,kCAAA;EACA,WAAA;EACA,gBAAA;AA2CJ;;AAvCA;EACE,YAAA;EACA,gCAAA;AA0CF;AAxCE;EACE,wBAAA;AA0CJ;;AAtCA;EACE,0BAAA;EACA,sBAAA;EACA,gDAAA;AAyCF;AAvCE;EACE,eAAA;AAyCJ;AAtCE;EACE,gBAAA;EACA,oBAAA;AAwCJ;;AAlCA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,+CAAA;AAqCF;;AAlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;AAqCF;;AAlCA;EACE,SAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAqCF;;AAlCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;EACA,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;AAqCF;AAnCE;EACE,oCAAA;EACA,WAAA;AAqCJ;AAlCE;EACE,mCAAA;AAoCJ;;AA9BA;EACE,aAAA;AAiCF;AA/BE;EAHF;IAII,eAAA;IACA,iBAAA;IACA,aAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,0BAAA;IACA,2BAAA;IACA,+BAAA;IACA,WAAA;EAkCF;AACF;;AA/BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAkCF;;AA/BA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAkCF;;AA7BA;EACE,aAAA;AAgCF;AA9BE;EAHF;IAII,eAAA;IACA,iBAAA;IACA,aAAA;IACA,aAAA;IACA,gDAAA;IACA,2DAAA;IACA,qCAAA;IACA,6BAAA;IACA,sCAAA;IACA,8CAAA;EAiCF;AACF;;AA9BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,eAAA;AAiCF;AA/BE;EACE,qBAAA;AAiCJ;AA9BE;EACE,0CAAA;AAgCJ;AA7BE;EACE,6BAAA;EACA,gBAAA;AA+BJ;;AAzBA;EACE,+BAAA;EACA,+BAAA;EACA,WAAA;AA4BF;;AAzBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;AA4BF;AA1BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;AA4BJ;;AAxBA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,gCAAA;AA2BF;AAzBE;EACE,gBAAA;EACA,oBAAA;AA2BJ;AAxBE;EACE,gBAAA;EACA,mBAAA;AA0BJ;;AAtBA;EACE,WAAA;EACA,YAAA;AAyBF","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","@import \"../../styles/tokens.scss\";\n\n.sq-shell {\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n.sq-skip {\n  position: absolute;\n  left: 0.75rem;\n  top: -4rem;\n  z-index: 2000;\n  padding: 0.5rem 0.875rem;\n  background: var(--sq-surface);\n  color: var(--sq-navy);\n  border-radius: var(--sq-radius-sm);\n  box-shadow: var(--sq-shadow-lg);\n  font-weight: 600;\n\n  &:focus {\n    top: 0.75rem;\n  }\n}\n\n// The window is the scroller, so sticky headers and iOS's collapsing address bar\n// behave. `min-width: 0` lets wide tables scroll inside their own region instead\n// of stretching this column — that stretch was the source of the page overflow.\n.sq-main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 100vh;\n  min-height: 100dvh;\n  margin-left: var(--sq-sidebar-w);\n\n  @media (max-width: $bp-shell) {\n    margin-left: 0;\n    min-height: 0;\n    padding-top: var(--sq-topbar-h);\n    padding-bottom: calc(var(--sq-bottomnav-h) + var(--sq-safe-bottom));\n  }\n}\n\n.sq-content {\n  flex: 1;\n  min-width: 0;\n}\n\n// Sidebar -------------------------------------------------------------------\n\n.sq-sidebar {\n  position: fixed;\n  inset: 0 auto 0 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  width: var(--sq-sidebar-w);\n  background: var(--sq-navy-deep);\n  color: #fff;\n\n  @media (max-width: $bp-shell) {\n    display: none;\n  }\n}\n\n.sq-sidebar-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 1rem 1.125rem 0.875rem;\n\n  img {\n    width: 36px;\n    height: 36px;\n    object-fit: cover;\n    border-radius: 8px;\n    display: block;\n  }\n\n  span {\n    font-size: 0.9375rem;\n    font-weight: 650;\n    letter-spacing: -0.01em;\n    color: #fff;\n  }\n}\n\n.sq-sidebar-nav {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.25rem 0.625rem 0.75rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n// Nav list (shared by the sidebar and the phone menu) -----------------------\n\n.sq-nav,\n.sq-nav-sub {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sq-nav > li + li {\n  margin-top: 2px;\n}\n\n.sq-nav-link {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  width: 100%;\n  min-height: 38px;\n  padding: 0.4rem 0.625rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: left;\n  text-decoration: none;\n  color: rgba(255, 255, 255, 0.78);\n  background: transparent;\n  border: 0;\n  border-radius: var(--sq-radius-sm);\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease;\n\n  svg {\n    flex-shrink: 0;\n  }\n\n  > span {\n    flex: 1;\n    min-width: 0;\n  }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.08);\n    color: #fff;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px var(--sq-sky);\n  }\n\n  &.is-within {\n    color: #fff;\n  }\n\n  &.active {\n    background: var(--sq-brand-strong);\n    color: #fff;\n    font-weight: 600;\n  }\n}\n\n.sq-nav-caret {\n  opacity: 0.6;\n  transition: transform 0.15s ease;\n\n  &.is-open {\n    transform: rotate(90deg);\n  }\n}\n\n.sq-nav-sub {\n  margin: 2px 0 4px 1.125rem;\n  padding-left: 0.625rem;\n  border-left: 1px solid rgba(255, 255, 255, 0.14);\n\n  li + li {\n    margin-top: 2px;\n  }\n\n  .sq-nav-link {\n    min-height: 34px;\n    font-size: 0.8125rem;\n  }\n}\n\n// Signed-in user ------------------------------------------------------------\n\n.sq-user {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.75rem 0.875rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.sq-user-avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  font-size: 0.8125rem;\n  font-weight: 700;\n  color: var(--sq-navy-deep);\n  background: var(--sq-sky);\n  border-radius: 50%;\n}\n\n.sq-user-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sq-user-logout {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  color: rgba(255, 255, 255, 0.78);\n  background: transparent;\n  border: 0;\n  border-radius: var(--sq-radius-sm);\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #fff;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px var(--sq-sky);\n  }\n}\n\n// Top bar -------------------------------------------------------------------\n\n.sq-topbar {\n  display: none;\n\n  @media (max-width: $bp-shell) {\n    position: fixed;\n    inset: 0 0 auto 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    gap: 0.625rem;\n    height: var(--sq-topbar-h);\n    padding: 0 var(--sq-page-x);\n    background: var(--sq-navy-deep);\n    color: #fff;\n  }\n}\n\n.sq-topbar-mark {\n  width: 30px;\n  height: 30px;\n  object-fit: cover;\n  border-radius: 7px;\n  flex-shrink: 0;\n}\n\n.sq-topbar-title {\n  min-width: 0;\n  font-size: 1rem;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// Bottom nav ----------------------------------------------------------------\n\n.sq-bottomnav {\n  display: none;\n\n  @media (max-width: $bp-shell) {\n    position: fixed;\n    inset: auto 0 0 0;\n    z-index: 1000;\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    height: calc(var(--sq-bottomnav-h) + var(--sq-safe-bottom));\n    padding-bottom: var(--sq-safe-bottom);\n    background: var(--sq-surface);\n    border-top: 1px solid var(--sq-border);\n    box-shadow: 0 -2px 10px rgba(16, 33, 47, 0.06);\n  }\n}\n\n.sq-bottomnav-link {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.1rem;\n  min-width: 0;\n  padding: 0.25rem 0.125rem;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: var(--sq-text-3);\n  background: transparent;\n  border: 0;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:hover {\n    color: var(--sq-navy);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px var(--sq-navy);\n  }\n\n  &.active {\n    color: var(--sq-brand-strong);\n    font-weight: 650;\n  }\n}\n\n// Phone menu ---------------------------------------------------------------\n\n.MuiPaper-root.sq-menu-sheet {\n  max-height: calc(100dvh - 48px);\n  background: var(--sq-navy-deep);\n  color: #fff;\n}\n\n.sq-menu-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.5rem 0.25rem 1.125rem;\n  font-size: 1rem;\n  font-weight: 650;\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    padding: 0;\n    color: #fff;\n    background: transparent;\n    border: 0;\n    border-radius: var(--sq-radius-sm);\n    cursor: pointer;\n  }\n}\n\n.sq-menu-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.25rem 0.625rem 0.5rem;\n\n  .sq-nav-link {\n    min-height: 44px;\n    font-size: 0.9375rem;\n  }\n\n  .sq-nav-sub .sq-nav-link {\n    min-height: 44px;\n    font-size: 0.875rem;\n  }\n}\n\n.sq-menu-sheet .sq-user-logout {\n  width: 44px;\n  height: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
